<div class="createPopup">
    <h2 mat-dialog-title class="dialogContainer">Are you sure you want to delete ?</h2>
    <button
      type="button"
      class="Close close1"
      data-dismiss="modal"
      mat-dialog-close >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
<div mat-dialog-content>
</div>

<div mat-dialog-actions class="Confirmbuttons">
  <button  mat-dialog-close class="btn" (click)="rideDelete()">Confirm</button>
  <button  mat-dialog-close class="btn">Close</button>
</div>
